var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14V9.1H2V6.3H5.33333V4.9H3.33333V0H8.66667V4.9H6.66667V6.3H10V9.1H12V14H6.66667V9.1H8.66667V7.7H3.33333V9.1H5.33333V14H0ZM4.66667 3.5H7.33333V1.4H4.66667V3.5ZM1.33333 12.6H4V10.5H1.33333V12.6ZM8 12.6H10.6667V10.5H8V12.6Z",
    fill: "#29B75A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanIcon);
export default __webpack_public_path__ + "static/media/lan-icon.8482a9a5f4dadf85f026157521c723d6.svg";
export { ForwardRef as ReactComponent };